import { useContext } from 'react'
import { complement, either, isNil, isEmpty } from 'ramda'

import BootstrapDataContext from '../../context/BootstrapDataContext'
import { Booking } from '../CrossSell/types'

const isTruthy = complement(either(isNil, isEmpty))

export default function useMostRecentFutureBooking() {
  const { mostRecentBooking } = useContext(BootstrapDataContext)
  return isTruthy(mostRecentBooking.future)
    ? (mostRecentBooking.future as Booking)
    : null
}
